/**
 * Trims the # from the beginning of routes to allow legacy route style
 * (i.e. #/users and/or /#/users)
 *
 * Replaces #/ with / but leaves the hash otherwise to support anchors
 * (i.e. /settings/general#logo)
 *
 * It would be really nice to remove this but first we'll need to change
 * all navigate calls and links to avoid #/
 */
export default function trimHashGuard(to, from, next) {
  if (to.hash.startsWith('#/')) {
    const path = to.hash.substr(1);
    next(path);
    return;
  }

  next();
}
